/**
 * SecurOne administration routes. Registered under /securone from
 * router/index.js. The parent view loads the context (the add-on gate),
 * connects the browser socket and hosts the screens.
 *
 * Roles: the four 1.0 roles that map onto the SecurOne actor model. The
 * reseller is deliberately absent (AR-S2). `securone_basic` lands here after
 * sign-in until it gets its own landing page.
 */
const meta = {
  authRequired: true,
  roles: ["admin", "superuser", "user", "securone_basic", "basic_user"],
};

export default [
  {
    path: "/securone",
    component: function() {
      return import("./SecurOne.vue");
    },
    meta,
    children: [
      { path: "", redirect: { name: "securone_overview" }, meta },
      { path: "overview", name: "securone_overview", component: () => import("./Overview.vue"), meta },
      { path: "categories", name: "securone_categories", component: () => import("./Categories.vue"), meta },
      { path: "categories/new", name: "securone_category_new", component: () => import("./CategoryEditor.vue"), meta },
      { path: "categories/:id", name: "securone_category_edit", component: () => import("./CategoryEditor.vue"), meta },
      { path: "send/:id?", name: "securone_broadcast", component: () => import("./BroadcastConfirm.vue"), meta },
      { path: "freetext", name: "securone_freetext", component: () => import("./FreeTextBroadcast.vue"), meta },
      { path: "groups", name: "securone_groups", component: () => import("./Groups.vue"), meta },
      { path: "groups/new", name: "securone_group_new", component: () => import("./GroupEditor.vue"), meta },
      { path: "groups/:id", name: "securone_group_edit", component: () => import("./GroupEditor.vue"), meta },
      { path: "users", name: "securone_users", component: () => import("./Users.vue"), meta },
      { path: "documents", name: "securone_documents", component: () => import("./Documents.vue"), meta },
      { path: "events", name: "securone_events", component: () => import("./Events.vue"), meta },
      { path: "events/:id", name: "securone_event", component: () => import("./EventDetail.vue"), meta },
    ],
  },
];
